import * as React from 'react';
import * as cx from 'classnames';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import { H2 } from 'ha/ui/Headers';

import { Question as QuestionType } from '../types';
import Question from './Question';

export interface Props {
  questions: QuestionType[];
}

const FAQ: React.SFC<Props & IntlProps> = ({ questions, intl: { T } }) => (
  <MediaQuery>
    {({ md }) => (
      <div
        className={cx(
          'back-purple color-white p-x-1_5 flexbox flex-align-center flex-direction__column',
          md ? 'p-t-5 p-b-3' : 'p-t-3 p-b-0_5',
        )}
      >
        <H2 className={cx('text-center', md ? 'm-b-5 font-size-xl' : 'm-b-3')}>
          {T('Frequently asked questions')}
        </H2>
        <ul className="fa-ul">
          {questions.map(question => (
            <li key={question.url} className={cx(md ? 'm-b-2' : 'm-b-2_5')}>
              <Question url={question.url} text={question.text} />
            </li>
          ))}
        </ul>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(FAQ);
